const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    if (tenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, tenantUuid);
      return;
    }
    localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};
